module.exports = __webpack_public_path__ + "static/media/booking-header.a2be0f2c.jpg";